module.exports = __webpack_public_path__ + "images/stickers/taco-love@2x.06ddf78e10598774b89e.png";